//import { MoneyLinkException } from "@/shared/utils/custom-exception";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { DownloadExcelTemplateService } from "@/features/accounts/csv-excel/services/download-template-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";

interface Props {
  onCompleteModal: () => void;
}

export const useDownloadExcelTemplate = ({onCompleteModal}: Props) => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const downloadExcelTemplateService = new DownloadExcelTemplateService();

  const downloadFile = (url: string, filename: string) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename; // ファイル名指定可
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  // Excel雛形取得
  const downloadExcelTemplate = async (csvExcelAccountId: string) => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await downloadExcelTemplateService.downloadExcelTemplate({
        csvexcel_account_id: csvExcelAccountId,
      });
      const headers = res.headers;
      const disposition = headers.get("content-disposition");
      let fileName = "download.xlsx";
      if (disposition) {
        // filename*=UTF-8''xxxx を優先
        const utf8Match = disposition.match(/filename\*=UTF-8''(.+)/);
      
        if (utf8Match?.[1]) {
          fileName = decodeURIComponent(utf8Match[1]);
        } else {
          // fallback
          const asciiMatch = disposition.match(/filename="?(.+?)"?$/);
          if (asciiMatch?.[1]) {
            fileName = asciiMatch[1];
          }
        }
      }
      const url = window.URL.createObjectURL(res.body);
      downloadFile(url, fileName);
      onCompleteModal();
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("downloadExcelTemplate", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    downloadExcelTemplate: errorHandledAsync(downloadExcelTemplate, setError),
  };
};
